import { render } from "./TreatmentsTable.vue?vue&type=template&id=4909dffc&ts=true"
import script from "./TreatmentsTable.vue?vue&type=script&lang=ts"
export * from "./TreatmentsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__